module.exports = __webpack_public_path__ + "img/condesa_ra_3.88c757ad.png";